import Vue from 'vue';
import { BfSpinner, BfButton, BfPanel } from 'components/Butterfly';
import ErrorPanel from 'components/widgets/ErrorPanel/ErrorPanel.vue';
import WidgetMessagePanel from 'components/widgets/WidgetMessagePanel/WidgetMessagePanel.vue';
import ResizeListener from 'components/widgets/ResizeListener/ResizeListener.vue';
import { markdown } from 'src/utils/formatters';
export default Vue.extend({
    components: { ErrorPanel, ResizeListener, BfSpinner, BfButton, BfPanel, WidgetMessagePanel },
    props: {
        banner: { type: Object, default: () => null, required: false },
        isLoading: { type: Boolean, default: false },
        zoomed: { type: Boolean, default: false },
        hasErrored: { type: Boolean, default: false },
        devMode: { type: Boolean, default: false },
        masked: { type: Boolean, default: true },
        sidePanelCollapsable: { type: Boolean, default: false },
    },
    data() {
        return {
            showDevPanel: false,
            collapsed: false,
        };
    },
    computed: {
        bannerHTML() {
            if (!this.banner?.message)
                return '';
            return markdown(this.banner?.message, true);
        },
        showSidePanel() {
            return this.sidePanelCollapsable && !this.collapsed;
        },
    },
    watch: {
        zoomed(old_value, new_value) {
            if (old_value !== new_value)
                this.resize();
        },
    },
    mounted() {
        setTimeout(() => {
            this.resize();
        }, 0);
    },
    methods: {
        resize: function () {
            this.$nextTick(() => {
                if (this.$el) {
                    const width = this.$el.getBoundingClientRect().width - (this.zoomed ? 350 : 40);
                    const height = this.zoomed ? this.$el.getBoundingClientRect().height - 160 : 600;
                    this.$emit('resize', width, height);
                }
            });
        },
        // this.$slots is not reactive so they cannot be computed properties
        hasFooter() {
            return !!this.$slots.footer;
        },
        hasMenu() {
            return !!this.$slots.menu;
        },
        hasPanel() {
            return !!this.$slots.panel;
        },
    }
});
